import script from "./ListPropertiesComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ListPropertiesComponent.vue?vue&type=script&setup=true&lang=js"

import "./ListPropertiesComponent.vue?vue&type=style&index=0&id=98cecd4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98cecd4a"]])

export default __exports__